import { PaginatedResponse } from '@/core/models/PaginatedResponse';
import { LocationQuery } from 'vue-router';

import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { EasypayEmployeeMapping } from '../../easypay-employee-mappings/easypay-employee-mapping.interface';
import { EasypayEmployeeMappingService } from './easypay-employee-mapping.service';

const service = new EasypayEmployeeMappingService();

export interface EasypayEmployeeMappingState {
   easypayEmployeeMappingsOverview?: PaginatedResponse<EasypayEmployeeMapping>;
}

const EasypayEmployeeMappingStore: Module<EasypayEmployeeMappingState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {
      SET_EASYPAY_EMPLOYEE_MAPPINGS_OVERVIEW: (state, overview: PaginatedResponse<EasypayEmployeeMapping>) =>
         (state.easypayEmployeeMappingsOverview = overview),
   },
   actions: {
      async getEasypayEmployeeMappings(context, payload: { easypayImportFileId: number; query?: LocationQuery }) {
         return await service.getEasypayEmployeeMappings(payload.easypayImportFileId, payload.query).then((response) => {
            context.commit('SET_EASYPAY_EMPLOYEE_MAPPINGS_OVERVIEW', response);
            return response;
         });
      },
   },
};

export default EasypayEmployeeMappingStore;
